import { Contain } from "@components/layout";
import useEnforceLoggedIn from "@hooks/useEnforceLoggedIn";
import { getWordpressVars } from "@lib/wordpressVars";
import {
    useGetPartnerDataQuery,
    useGetSubscriptionsByPartnerIdQuery
} from "@ppServices/Partners";
import { Col, Collapse, Layout, Row, Spin } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import EditProfileButton from "@ppPartials/edit-profile-button";
import Header from "../../partials/header";
import MainNav from "../../partials/main-nav";


const ProfileSubscriptions = ({ subscriptions }) => {

    const [subsc, setSubsc] = useState<any>([]);

    useEffect(() => {

        if (subscriptions) {
            setSubsc(subscriptions);
        }

    }, [subscriptions]);

    return (
        <>
            {subsc?.map((subs) =>
                <Row
                    key={subs?.id}
                    className={`grey-well mar-bot-20`}
                    justify={`space-between`}
                    align={`middle`}
                >
                    <Col>
                        {subs.subTitle
                            && <h1 style={{
                                marginBottom: !!subs.description ? 0 : 'inherit'
                            }}>{subs.subTitle}</h1>}

                        {!!subs.description &&
                            <p>
                                <strong>Details:</strong> {subs.description}<br />
                            </p>}
                    </Col>
                    <Col>
                        <span className={`status`}>
                            Status: <span className={subs.status}>{subs.status}</span>
                        </span>
                    </Col>
                </Row>
            )}

        </>
    )
}

const ProfileDetails = ({ details }) => {

    return (
        <Row gutter={15}>
            <Col span={`12`}>
                <Collapse
                    defaultActiveKey={['0', '1']}
                    expandIconPosition={"end"}
                    ghost
                >
                    <CollapsePanel
                        header={`Business Information`}
                        collapsible={`icon`}
                        className={`info`}
                        key={"0"}
                    >
                        {details?.partner
                            && <ul>
                                {details?.partner?.businessName &&
                                    <li>
                                        Business Name: <strong>{details.partner.businessName}</strong>
                                    </li>
                                }
                                {details?.partner?.email &&
                                    <li>
                                        Email: <strong>{details.partner.email}</strong>
                                    </li>
                                }
                                {details?.partner?.billingAddress &&
                                    <li>
                                        Billing Address: <strong>{details.partner.billingAddress}</strong>
                                    </li>
                                }
                            </ul>}

                    </CollapsePanel>

                </Collapse>

            </Col>

            <Col span={`12`}>

                <Collapse
                    defaultActiveKey={['0', '1']}
                    expandIconPosition={"start"}
                    ghost
                >
                    <CollapsePanel
                        header={`Account Management`}
                        collapsible={`icon`}
                        className={`info`}
                        key={"1"}
                        extra={

                            <EditProfileButton
                                type={`link`}
                                pointOfContactInfo={details.partnerPointOfContact}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            />
                        }
                    >
                        {details.partnerPointOfContact &&
                            <ul>
                                <li>Password: **********</li>
                                <li>Point of Contact:  {details.partnerPointOfContact.firstName} {details.partnerPointOfContact.lastName} </li>
                                {details.partnerPointOfContact.phoneNumber &&
                                    <li>
                                        Phone:  {details.partnerPointOfContact.phoneNumber}
                                    </li>}
                            </ul>}
                    </CollapsePanel>
                </Collapse>
            </Col>
        </Row>
    )
}

const Profile = () => {
    const { user, isSuccess } = useEnforceLoggedIn();

    const { title } = getWordpressVars();

    const [main, setMain] = useState<any>({});

    const [partnerSubscriptions, setPartnerSubscriptions] = useState<any>([]);

    const userDataByIdQuery = useGetPartnerDataQuery({
        userId: user?.id
    }, { skip: !isSuccess });

    const partnerSubscriptionsQuery = useGetSubscriptionsByPartnerIdQuery({
        userId: user?.id
    }, { skip: !isSuccess });

    useEffect(() => {
        if (userDataByIdQuery.data) {
            setMain(userDataByIdQuery.data);
        }

    }, [userDataByIdQuery.data])

    useEffect(() => {

        if (partnerSubscriptionsQuery.data?.subscriptions) {
            setPartnerSubscriptions(partnerSubscriptionsQuery.data.subscriptions);
        }

    }, [partnerSubscriptionsQuery.data])


    return (
        <Layout className="pp-profile-page">

            <Head>
                <title>{title} - CovrPrice</title>
            </Head>

            <MainNav />

            <Header
                partnerLogoUrl={main?.partner?.partnerLogoUrl}
                partnerHelpInfo={main?.customerServiceRep}
            />

            <Spin spinning={
                partnerSubscriptionsQuery.isLoading ||
                partnerSubscriptionsQuery.isFetching
            }>
                <Contain className={`mar-bot-30 pad-x-30`}>
                    <Row>
                        <Col>
                            <h1>Account Details</h1>
                        </Col>
                    </Row>

                    <ProfileSubscriptions
                        subscriptions={partnerSubscriptions}
                    />

                    <ProfileDetails
                        details={main}
                    />

                </Contain>
            </Spin>

        </Layout>
    );
};

export default Profile;
